export default {
  simulation: 'Mode simulation (aucun argent réel)',
  worker: {
    title: 'Versement de ma paie',
    explain: 'Configurez une seule fois le compte où recevoir votre paie (travailleur autonome). La configuration se fait sur la page sécurisée de Stripe.',
    incomplete: 'La configuration de votre compte de versement n’est pas terminée.',
    enabled: 'Votre compte est prêt : votre paie approuvée y sera versée.',
    privacy: 'Vos informations bancaires sont saisies chez Stripe et ne sont jamais conservées dans l’application.',
    setup: 'Configurer mes versements',
    continue: 'Terminer la configuration',
    ready: 'Votre compte de versement est prêt.',
    resume: 'La configuration a été interrompue. Vous pouvez la reprendre.',
  },
  admin: {
    title: 'Versements aux employés',
    explain: 'Envoie la paie approuvée sur le compte de chaque travailleur autonome (un virement par personne).',
    payAll: 'Verser la paie approuvée ({{amount}})',
    ready: 'Prêt',
    incomplete: 'Configuration incomplète',
    noAccount: 'Compte non configuré',
    history: 'Derniers versements',
    entries_one: '{{count}} ménage',
    entries_other: '{{count}} ménages',
    confirmTitle: 'Verser {{amount}} ?',
    confirmText_one: 'Un virement sera envoyé à {{count}} employé. Les employés sans compte prêt sont ignorés.',
    confirmText_other: 'Un virement sera envoyé à chacun des {{count}} employés. Les employés sans compte prêt sont ignorés.',
    confirm: 'Verser maintenant',
    done_one: '{{count}} versement envoyé ({{amount}}). Ignorés : {{skipped}}.',
    done_other: '{{count}} versements envoyés ({{amount}}). Ignorés : {{skipped}}.',
  },
  status: { PENDING: 'En cours', PAID: 'Versé', FAILED: 'Échoué' },
};
